"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubNavLinks = exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
require("@xo-union/tk-ui-essentials");
var _react = _interopRequireWildcard(require("react"));
var _tkUiSubNav = require("@xo-union/tk-ui-sub-nav");
var _SubNavModule = _interopRequireDefault(require("./SubNav.module.css"));
var _SubNavElementLink = _interopRequireDefault(require("../SubNavElementLink/SubNavElementLink.js"));
var _SubNavIconLink = _interopRequireDefault(require("../SubNavIconLink/SubNavIconLink.js"));
var _SearchButton = _interopRequireDefault(require("../SearchButton/SearchButton.js"));
var _SubNavButton = _interopRequireDefault(require("../SubNavButton/SubNavButton.js"));
var _GlobalVariables = _interopRequireDefault(require("../../styles/Variables/GlobalVariables.js"));
var _tkUiBreakpoints = require("@xo-union/tk-ui-breakpoints");
var _SubNavContext = require("../../context/SubNavContext.js");
var _EventPreventionWrapper = require("../EventPreventionWrapper/EventPreventionWrapper.js");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getSubNavLinks = (links, additionalLink) => {
  return [...links, additionalLink];
};
exports.getSubNavLinks = getSubNavLinks;
const SubNav = _ref => {
  var _useMedia;
  let {
    tenant,
    links,
    subNavButtons,
    rightSideLinks,
    onSearch,
    searchBarPlaceholder,
    MenuItemComponent,
    trackMenuInteraction,
    trackProductsSearched,
    trackSearchInitialized,
    withExperiment,
    additionalLink
  } = _ref;
  const [isSearchBarRendered, setIsSearchBarRendered] = (0, _react.useState)(false);
  const isDesktop = (_useMedia = (0, _tkUiBreakpoints.useMedia)('(min-width: 950px)')) === null || _useMedia === void 0 ? void 0 : _useMedia.yes;
  (0, _react.useEffect)(() => {
    setIsSearchBarRendered(!isDesktop);
  }, [isDesktop]);
  const iconButtonSectionStyles = [_SubNavModule.default.subNav__iconButtonSection];
  const subNavLinks = additionalLink ? getSubNavLinks(links, additionalLink) : links;
  return /*#__PURE__*/_react.default.createElement(_SubNavContext.SubNavProvider, {
    tenant: tenant,
    MenuItemComponent: MenuItemComponent,
    trackMenuInteraction: trackMenuInteraction,
    trackProductsSearched: trackProductsSearched,
    trackSearchInitialized: trackSearchInitialized,
    withExperiment: withExperiment,
    additionalLink: additionalLink
  }, /*#__PURE__*/_react.default.createElement(_GlobalVariables.default, null, /*#__PURE__*/_react.default.createElement(_tkUiSubNav.SubNavContainer, {
    analyticsProps: {
      product: 'paper'
    },
    links: /*#__PURE__*/_react.default.createElement("div", {
      className: _SubNavModule.default.subNav__linkSection,
      "data-testid": "SubNav__links"
    }, !isSearchBarRendered && /*#__PURE__*/_react.default.createElement(_EventPreventionWrapper.EventPreventionWrapper, {
      className: _SubNavModule.default.subNav__linksContainer,
      "data-testid": "SubNav__linksContainer"
    }, subNavLinks === null || subNavLinks === void 0 ? void 0 : (0, _map.default)(subNavLinks).call(subNavLinks, data => /*#__PURE__*/_react.default.createElement(_SubNavElementLink.default, {
      key: data.text,
      text: data.text,
      href: data.href,
      target: data.target,
      links: data.links
    })), subNavButtons === null || subNavButtons === void 0 ? void 0 : (0, _map.default)(subNavButtons).call(subNavButtons, data => /*#__PURE__*/_react.default.createElement(_SubNavButton.default, {
      key: data.title,
      onClick: data.onClick,
      title: data.title
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: iconButtonSectionStyles.join(' '),
      "data-testid": "SubNav__iconButtonSection"
    }, /*#__PURE__*/_react.default.createElement(_SearchButton.default, {
      isSearchBarRendered: isSearchBarRendered,
      setIsSearchBarRendered: setIsSearchBarRendered,
      onSearch: onSearch,
      searchBarPlaceholder: searchBarPlaceholder
    }), rightSideLinks === null || rightSideLinks === void 0 ? void 0 : (0, _map.default)(rightSideLinks).call(rightSideLinks, data => /*#__PURE__*/_react.default.createElement(_SubNavIconLink.default, {
      key: data.href,
      iconName: data.iconName,
      text: data.text,
      size: "md",
      ariaLabel: data.ariaLabel,
      href: data.href,
      hasBadge: data.hasBadge,
      badgeValue: data.badgeValue
    }))))
  })));
};
var _default = exports.default = SubNav;